/* eslint-disable prettier/prettier */
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

export type PrintAreaCustomizationOutput = {
  printAreaCustomizationId: string;
  canvas: HTMLCanvasElement;
};

@Module({
  stateFactory: true,
  namespaced: false,
  name: "output",
})
export default class Output extends VuexModule {
  private _outputs: PrintAreaCustomizationOutput[] = [];

  get outputById(): any {
    return (id: string) => {
      return (
        this._outputs.find(
          (item: PrintAreaCustomizationOutput) =>
            id.toString() === item.printAreaCustomizationId.toString()
        ) || null
      );
    };
  }

  get outputs() {
    return this._outputs;
  }

  @Mutation
  setOutput(payload: PrintAreaCustomizationOutput) {

    const output =
      this._outputs.find(
        (item: PrintAreaCustomizationOutput) =>
          payload.printAreaCustomizationId === item.printAreaCustomizationId
      ) || null;

      const canvas = document.createElement('canvas');
      canvas.width = payload.canvas.width;
      canvas.height = payload.canvas.height;

      const ctx = canvas.getContext('2d');    
      ctx.drawImage(payload.canvas, 0, 0);

    if (!output) {
      this._outputs.push({printAreaCustomizationId: payload.printAreaCustomizationId, canvas});
    } else {
      output.canvas = canvas;
    }
  }
}
